import swal from "sweetalert"

import { Table } from "common/Table/Table"
import { useNotifications } from "hooks/useNotification"
import { Fragment, useCallback, useEffect, useState } from "react"
import UserService from "services/user.service"
import { convertTimestamp, exportToCSV, formatDate } from "utils/funcs"
import { formatPhone } from "./Contacts"
import DatePicker from "react-datepicker"
import { DATE } from "./trainings/WeeklyStats"
import moment from "moment"
import { Modal } from "common/Modal"
import Select from "react-select"
import { useDebounce } from "hooks/useDebounce"

const service = new UserService()

export const SaleAds = () => {
  const [showCandidate, setShowCandidate] = useState(false)

  const columns = [
    { key: "first_name", dbColName: "first_name", title: "first_name" },
    { key: "last_name", dbColName: "last_name", title: "last_name" },
    // {key: "rep_id", dbColName: "rep_id", title: "rep_id"},
    {
      key: "phone",
      dbColName: "phone",
      title: "phone",
      render: (phone) => formatPhone(phone),
    },
    { key: "lead_stage", dbColName: "lead_stage", title: "lead stage" },
    // {key: "email", dbColName: "email", title: "email"},
    { key: "source", dbColName: "source", title: "source" },
    { key: "type", dbColName: "type", title: "type" },
    // {
    //   key: "social_media_ad_id",
    //   dbColName: "social_media_ad_id",
    //   title: "social_media_ad_id",
    // },
    { key: "address", dbColName: "address", title: "address" },
    { key: "city", dbColName: "city", title: "city" },
    { key: "state", dbColName: "state", title: "state" },
    { key: "age", dbColName: "age", title: "age" },
    { key: "credit_score", dbColName: "credit_score", title: "credit_score" },
    {
      key: "select_if_applicable",
      dbColName: "select_if_applicable",
      title: "select_if_applicable",
    },
    {
      key: "smart_home_status",
      dbColName: "smart_home_status",
      title: "smart_home_status",
    },
    {
      key: "new_roof_needed",
      dbColName: "new_roof_needed",
      title: "new_roof_needed",
    },
    {
      key: "square_footage",
      dbColName: "square_footage",
      title: "square_footage",
    },
    { key: "notes", dbColName: "notes", title: "notes" },
    {
      key: "most_recent_update",
      dbColName: "most_recent_update",
      title: "most_recent_update",
      render: (date) => convertTimestamp(date),
    },
    {
      key: "most_recent_lead_stage",
      dbColName: "most_recent_lead_stage",
      title: "most_recent_lead_stage",
    },
    {
      key: "follow_up_date",
      dbColName: "follow_up_date",
      title: "follow_up_date",
    },
    {
      key: "follow_up_time",
      dbColName: "follow_up_time",
      title: "follow_up_time",
    },
    {
      key: "follow_up_notes",
      dbColName: "follow_up_notes",
      title: "follow_up_notes",
    },
    {
      key: "follow_up_time_zone",
      dbColName: "follow_up_time_zone",
      title: "follow_up_time_zone",
    },
    {
      key: "follow_up_schedule",
      dbColName: "follow_up_schedule",
      title: "follow_up_schedule",
    },
    {
      key: "follow_up_most_recent_update",
      dbColName: "follow_up_most_recent_update",
      title: "follow_up_most_recent_update",
      render: (date) => convertTimestamp(date),
    },
    {
      key: "lead_screening_result_most_recent_update",
      dbColName: "lead_screening_result_most_recent_update",
      title: "lead_screening_result_most_recent_update",
      render: (date) => convertTimestamp(date),
    },
    {
      key: "lead_screeing_result",
      dbColName: "lead_screeing_result",
      title: "lead_screeing_result",
    },
    {
      key: "lead_screening_notes",
      dbColName: "lead_screening_notes",
      title: "lead_screening_notes",
    },
    {
      key: "solar_lead_interest_notes",
      dbColName: "solar_lead_interest_notes",
      title: "solar_lead_interest_notes",
    },
    {
      key: "lead_interest_most_recent_update",
      dbColName: "lead_interest_most_recent_update",
      title: "lead_interest_most_recent_update",
      render: (date) => convertTimestamp(date),
    },
    {
      key: "solar_lead_interest",
      dbColName: "solar_lead_interest",
      title: "solar_lead_interest",
    },
    {
      key: "out_reach_notes",
      dbColName: "out_reach_notes",
      title: "out_reach_notes",
    },
    {
      key: "out_reach_email_time_stamp",
      dbColName: "out_reach_email_time_stamp",
      title: "out_reach_email_time_stamp",
      render: (date) => convertTimestamp(date),
    },
    {
      key: "out_reach_text",
      dbColName: "out_reach_text",
      title: "out_reach_text",
    },
    {
      key: "out_reach_most_recent_update",
      dbColName: "out_reach_most_recent_update",
      title: "out_reach_most_recent_update",
      render: (date) => convertTimestamp(date),
    },
    {
      key: "out_reach_phone",
      dbColName: "out_reach_phone",
      title: "out_reach_phone",
    },
    {
      key: "out_reach_social",
      dbColName: "out_reach_social",
      title: "out_reach_social",
    },
    {
      key: "out_reach_phone_time_stamp",
      dbColName: "out_reach_phone_time_stamp",
      title: "out_reach_phone_time_stamp",
      render: (date) => convertTimestamp(date),
    },
    {
      key: "out_reach_text_time_stamp",
      dbColName: "out_reach_text_time_stamp",
      title: "out_reach_text_time_stamp",
      render: (date) => convertTimestamp(date),
    },
    {
      key: "out_reach_email",
      dbColName: "out_reach_email",
      title: "out_reach_email",
    },
    {
      key: "out_reach_social_time_stamp",
      dbColName: "out_reach_social_time_stamp",
      title: "out_reach_social_time_stamp",
      render: (date) => convertTimestamp(date),
    },
    {
      key: "pitch_schedule_office_name",
      dbColName: "pitch_schedule_office_name",
      title: "pitch_schedule_office_name",
    },
    {
      key: "pitch_schedule_time_zone",
      dbColName: "pitch_schedule_time_zone",
      title: "pitch_schedule_time_zone",
    },
    {
      key: "pitch_schedule_date_and_time",
      dbColName: "pitch_schedule_date_and_time",
      title: "pitch_schedule_date_and_time",
    },
    {
      key: "pitch_schedule_most_recent_update",
      dbColName: "pitch_schedule_most_recent_update",
      title: "pitch_schedule_most_recent_update",
      render: (date) => convertTimestamp(date),
    },
    {
      key: "assign_closure_most_recent_update",
      dbColName: "assign_closure_most_recent_update",
      title: "assign_closure_most_recent_update",
      render: (date) => convertTimestamp(date),
    },
    {
      key: "assign_closure_name",
      dbColName: "assign_closure_name",
      title: "assign_closure_name",
    },
    {
      key: "assign_closure_badge_id",
      dbColName: "assign_closure_badge_id",
      title: "assign_closure_badge_id",
    },
    { key: "zip_code", dbColName: "zip_code", title: "zip_code" },
    { key: "office_name", dbColName: "office_name", title: "office_name" },
    {
      key: "power_bill_image",
      dbColName: "power_bill_image",
      title: "power_bill_image",
    },
    {
      key: "leader_id",
      dbColName: "candidate",
      title: "leader_id",
      render: (candidate) => candidate?.leader_id ?? "",
    },
    {
      key: "leader_name",
      dbColName: "candidate",
      title: "leader_name",
      render: (candidate) => candidate?.leader_name ?? "",
    },
    {
      key: "leader_phone_number",
      dbColName: "candidate",
      title: "leader_phone_number",
      render: (candidate) => candidate?.leader_phone_number ?? "",
    },
    {
      key: "leader_email",
      dbColName: "candidate",
      title: "leader_email",
      render: (candidate) => candidate?.leader_email ?? "",
    },
    {
      key: "recruiter_name",
      dbColName: "candidate",
      title: "recruiter_name",
      render: (candidate) => candidate?.recruiter_name ?? "",
    },
    {
      key: "team_name",
      dbColName: "candidate",
      title: "team_name",
      render: (candidate) => candidate?.team_name ?? "",
    },
    {
      key: "mgmt_group_name",
      dbColName: "candidate",
      title: "mgmt_group_name",
      render: (candidate) => candidate?.mgmt_group_name ?? "",
    },
    {
      key: "sr_mgmt_group_name",
      dbColName: "candidate",
      title: "sr_mgmt_group_name",
      render: (candidate) => candidate?.sr_mgmt_group_name ?? "",
    },
    {
      key: "region_name",
      dbColName: "candidate",
      title: "region_name",
      render: (candidate) => candidate?.region_name ?? "",
    },
    {
      key: "senior_region_name",
      dbColName: "candidate",
      title: "senior_region_name",
      render: (candidate) => candidate?.senior_region_name ?? "",
    },
    {
      key: "partnership_name",
      dbColName: "candidate",
      title: "partnership_name",
      render: (candidate) => candidate?.partnership_name ?? "",
    },
    {
      key: "division_name",
      dbColName: "candidate",
      title: "division_name",
      render: (candidate) => candidate?.division_name ?? "",
    },
    {
      key: "createdAt",
      dbColName: "createdAt",
      title: "createdAt",
      render: (date) => formatDate(date),
    },
    {
      key: "actions",
      title: "actions",
      freeze: true,
      freezeIndex: "right-0",
      render: ({ _id }) => {
        return (
          <div className="flex items-center gap-2">
            <button
              onClick={() => handleDelete(_id)}
              className="p-2 text-xs text-red-500 rounded-md "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                />
              </svg>
            </button>
          </div>
        )
      },
    },
  ]

  // const columns = [
  //     {
  //       key: "FULL_NAME",
  //       title: "FULL NAME",
  //       label: "FULL NAME",
  //       freeze: true,
  //       freezeIndex: "left-0 min-w-[190px]",
  //       color: "bg-[#ECEEEF] text-black ",
  //       render: (
  //        values
  //       ) =>values?.first_name + " " + values?.last_name

  //     },

  //     {
  //       key: "CANDIDATE_STAGE_ICON",
  //       title: "LEAD STAGE",
  //       render: (value: {
  //         lead_stge: string;
  //         first_name: string;
  //         last_name: string;
  //       }) => {
  //         return (
  //           <CandidateStage
  //             firstName={value.first_name}
  //             lastName={value.last_name}
  //             stage={value.lead_stge}
  //           />
  //         );
  //       },
  //     },
  //     {
  //       key: "EMAIL",
  //       title: "EMAIL",
  //       label: "EMAIL",
  //       dbColName: "email",
  //       render: (e) => <CopyText copyText={e} text={e} />,
  //     },
  //     {
  //       key: "phone",
  //       dbColName: "phone",
  //       title: "phone",
  //       render: (phone) => (
  //         <CopyText copyText={phone} text={formatPhone(phone)} />
  //       ),
  //     },
  //     {
  //         key: "OUTREACH_email",
  //         title: "OUTREACH email",
  //         label: "OUTREACH email",
  //         dbColName: "out_reach_email",
  //         color: "bg-green-300 text-black",
  //     },
  //     {
  //       key: "OUTREACH_notes",
  //       title: "OUTREACH NOTES",
  //       label: "OUTREACH NOTES",
  //       dbColName: "out_reach_notes",
  //       color: "bg-green-300 text-black",

  //     },
  //     {
  //         key: "out_reach_phone",
  //         title: "OUTREACH phone",
  //         label: "OUTREACH phone",
  //         dbColName: "out_reach_phone",
  //         color: "bg-green-300 text-black",

  //       },
  //     {
  //       key: "INTRO_VIDEO",
  //       title: "INTRO VIDEO",
  //       label: "INTRO VIDEO",
  //       dbColName: "INTRO_VIDEO",
  //       color: "bg-green-300 text-black",

  //     },
  //     {
  //       key: "FOLLOW_UP",
  //       title: "FOLLOW UP",
  //       label: "FOLLOW UP",
  //       dbColName: "follow_up_date",
  //       color: "bg-green-300 text-black",

  //     },

  //     {
  //       key: "FOLLOW_UP_CALL_TIME",
  //       title: "FOLLOW UP TIME",
  //       label: "follow_up_time",
  //       dbColName: "follow_up_time",
  //       color: "bg-green-300 text-black",

  //     },

  //   ];

  const { errorMessage, successMessage } = useNotifications()

  const [data, setData] = useState([])
  const [addModal, setAddModal] = useState(false)
  const [exporting, setExporting] = useState(false)
  const [date, setDate] = useState("YEARTODATE")
  const [users, setUsers] = useState([])
  const [submitting, setSubmitting] = useState(false)
  const [loadingUsers, setLoadingUsers] = useState(false)
  const [loading, setLoading] = useState(false)
  const [totalItems, setTotalItems] = useState(0)
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 100,
    lead_stage: "",
    state: "",
    date: "",
    fullName: "",
    type: "",
  })
  const [state, setState] = useState({
    rep_id: "",
    first_name: "",
    last_name: "",
    phone: "",
    type: "Solar",
    source: "Direct Lead",
    email: "",
    address: "",
    city: "",
    state: "",
    zip_code: "",
    age: "",
    credit_score: "",
    smart_home_status: "",
    select_if_applicable: "",
    new_roof_needed: "",
    square_footage: "",
    notes: "",
  })
  const [searchValue, setSearchValue] = useState("")

  const debounced = useDebounce(searchValue, 500)

  useEffect(() => {
    setLoadingUsers(true)
    service
      .getSignedReps({
        repName: debounced,
        pageNumber: 1,
        year: "All",
        pageSize: 100,
      })
      .then((resp) => {
        setUsers(
          resp.data.data.map((item) => ({
            value: item.rep_id,
            label: item.rep_name,
          }))
        )
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoadingUsers(false)
      })
  }, [debounced])

  const handleChange = (e) => {
    const { name, value } = e.target

    setState({
      ...state,
      [name]: value,
    })
  }

  const handleChangePhone = (e) => {
    let input = e.target.value

    // Remove any non-digit characters
    input = input.replace(/\D/g, "")

    // Limit to 10 digits maximum
    if (input.length > 10) {
      input = input.slice(0, 10)
    }

    setState({ ...state, phone: input })
  }

  const handleKeyPress = (e) => {
    // Only allow digits
    if (
      !/\d/.test(e.key) &&
      !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)
    ) {
      e.preventDefault()
    }
  }

  const fetchData = useCallback(() => {
    setLoading(true)
    service
      .getAllSolarLeads(pagination)
      .then((resp) => {
        const body = resp?.data ?? {}
        const rawList = Array.isArray(body.data)
          ? body.data
          : Array.isArray((body as any).results)
            ? (body as any).results
            : Array.isArray((body as any).records)
              ? (body as any).records
              : []
        const totalCount =
          Number(body.totalDocument) ||
          Number(body.total_docs) ||
          Number(body.total) ||
          rawList.length
        setData(rawList)
        setTotalItems(totalCount)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [pagination])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const handleAddSale = (e) => {
    e.preventDefault()

    const requiredFields = [state.first_name, state.last_name, state.email, state.phone]
    const allFilled = requiredFields.every(item => item)

    if (!allFilled) {
      errorMessage("Fill out all fields")
      return
    }

    service
      .addSolarLead(state)
      .then((resp) => {
        successMessage("Lead added successfully")
        fetchData()
        setAddModal(false)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleDelete = (id: string) => {
    swal({
      title: "Are you sure, you want to delete this lead?",
      icon: "warning",
      className: "w-[500px]",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
        },
        confirm: {
          text: "Delete",
          className: "bg-primary text-white",
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true)
        service
          .deleteSolarLead(id)
          .then((resp) => {
            successMessage("Lead deleted successfully")
            fetchData()
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            setLoading(false)
          })
      }
    })
  }

  const handleExport = () => {
    setExporting(true)
    exportToCSV(data, "sale_ads")
    setExporting(false)
  }

  return (
    <Fragment>
      <div className="flex items-center justify-between">
        <div className="flex flex-col mb-4 ">
          <h1 className="page-title">
            Leads
          </h1>
          <p className="page-subtitle">View all leads</p>
        </div>
        <button
          onClick={() => setAddModal(true)}
          className="btn-dark"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 6v12m6-6H6"
            />
          </svg>
          Add Lead
        </button>
      </div>
      <Table
        data={data}
        loadingData={loading}
        setPagination={setPagination}
        exporting={exporting}
        handleExport={handleExport}
        pagination={pagination}
        totalItems={totalItems || data.length}
        showSearch={false}
        columns={columns}
        filters={
          <ColumnFilters
            date={date}
            setDate={setDate}
            pagination={pagination}
            setPagination={setPagination}
          />
        }
      />

      <Modal
        width="w-full md:w-1/3"
        showModal={addModal}
        setShowModal={setAddModal}
        title="Add Sale Ad"
      >
        <form onSubmit={handleAddSale} className="flex flex-col gap-3">
          <div className="grid grid-cols-2 gap-3">
            {/* <div className="flex flex-col gap-1">
            <label className="field-label">Ad ID</label>
            <input
              type="text"
              placeholder="Enter Ad ID"
              value={state.social_media_ad_id}
              required
              name="social_media_ad_id"
              onChange={(e) => handleChange(e)}
              className="w-full px-3 py-2 text-sm"
            />
          </div> */}
            <div className="flex flex-col gap-1">
              <label className="field-label">First Name</label>
              <input
                type="text"
                placeholder="Enter first name"
                value={state.first_name}
                required
                name="first_name"
                onChange={(e) => handleChange(e)}
                className="w-full px-3 py-2 text-sm"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="field-label">Last Name</label>
              <input
                type="text"
                placeholder="Enter last name"
                value={state.last_name}
                required
                name="last_name"
                onChange={(e) => handleChange(e)}
                className="w-full px-3 py-2 text-sm"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="field-label">Email</label>
              <input
                type="email"
                placeholder="Enter email"
                value={state.email}
                required
                name="email"
                onChange={(e) => handleChange(e)}
                className="w-full px-3 py-2 text-sm"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="field-label">Phone</label>
              <input
                type="number"
                placeholder="Enter phone number"
                value={state.phone}
                required
                name="phone"
                onChange={handleChangePhone}
                onKeyDown={handleKeyPress}
                className="w-full px-3 py-2 text-sm"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="field-label">Address</label>
              <input
                type="text"
                placeholder="Enter address"
                value={state.address}
                required
                name="address"
                onChange={(e) => handleChange(e)}
                className="w-full px-3 py-2 text-sm"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="field-label">City</label>
              <input
                type="text"
                placeholder="Enter city"
                value={state.city}
                required
                name="city"
                onChange={(e) => handleChange(e)}
                className="w-full px-3 py-2 text-sm"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="field-label">State</label>
              <input
                type="text"
                placeholder="State"
                value={state.state}
                required
                name="state"
                onChange={(e) => handleChange(e)}
                className="w-full px-3 py-2 text-sm"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="field-label">Zip Code</label>
              <input
                type="number"
                placeholder="Enter zip code"
                value={state.zip_code}
                required
                name="zip_code"
                onChange={(e) => handleChange(e)}
                className="w-full px-3 py-2 text-sm"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="field-label">Source</label>
              <select
                value={state.source}
                onChange={e => setState({ ...state, source: e.target.value })}
                className="w-full px-3 py-2 text-sm"
              >
                <option value="">Select</option>
                {["Direct Lead", "Social Media", "Website"].map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>

            </div>

            {/* <div className="flex flex-col gap-1">
              <label className="field-label">Credit Score</label>
              <input
                type="text"
                placeholder="Enter credit score"
                value={state.credit_score}
                required
                name="credit_score"
                onChange={(e) => handleChange(e)}
                className="w-full px-3 py-2 text-sm"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="field-label">Smart Home Status</label>
              <input
                type="text"
                placeholder="Enter smart home status"
                value={state.smart_home_status}
                required
                name="smart_home_status"
                onChange={(e) => handleChange(e)}
                className="w-full px-3 py-2 text-sm"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="field-label">
                Select if applicable
              </label>
              <input
                type="text"
                placeholder="Enter select if applicable"
                value={state.select_if_applicable}
                required
                name="select_if_applicable"
                onChange={(e) => handleChange(e)}
                className="w-full px-3 py-2 text-sm"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="field-label">New Roof Needed</label>
              <input
                type="text"
                placeholder="Enter select if applicable"
                value={state.new_roof_needed}
                required
                name="new_roof_needed"
                onChange={(e) => handleChange(e)}
                className="w-full px-3 py-2 text-sm"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="field-label">Square Footage</label>
              <input
                type="text"
                placeholder="Enter square footage"
                value={state.square_footage}
                required
                name="square_footage"
                onChange={(e) => handleChange(e)}
                className="w-full px-3 py-2 text-sm"
              />
            </div> */}
            <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
              <label className="field-label">Assigned To</label>
              <Select
                options={users}
                placeholder="Search"
                onChange={(ev: any) =>
                  setState({
                    ...state,
                    rep_id: ev.value,
                  })
                }
                isLoading={loadingUsers}
                onInputChange={(newValue) => setSearchValue(newValue)}
                className="react-select"
                classNamePrefix="react-select"
              />
            </div>
          </div>
          <div className="flex flex-col gap-1">
            <label className="field-label">Notes</label>
            <textarea
              placeholder="Enter notes"
              value={state.notes}
              required
              name="notes"
              onChange={(e) => setState({ ...state, notes: e.target.value })}
              className="w-full px-3 py-2 text-sm"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="py-2 text-white bg-ink hover:bg-gray-800 rounded-lg disabled:opacity-25"
          >
            {submitting ? "Saving..." : "Save"}
          </button>
        </form>
      </Modal>
    </Fragment>
  )
}

const ColumnFilters = ({ date, setDate, pagination, setPagination }) => {
  const [startDate, setStartDate] = useState<any>(null)
  const [endDate, setEndDate] = useState<any>(null)
  const [showCustom, setShowCustom] = useState(false)

  const onChangeCreated = (dates) => {
    const [start, end] = dates

    setStartDate(start)
    setEndDate(end)

    if (start && end) {
      setPagination({
        ...pagination,
        date: `${moment(start).format("YYYY-MM-DD")},${moment(end).format(
          "YYYY-MM-DD"
        )}`,
      })
    }
  }

  return (
    <div className="flex items-center flex-1 gap-4">
      <input
        className="px-4 py-2 text-sm font-light text-gray-800 border-gray-200 rounded-md focus:border-gray-300 focus:outline-none w-60 focus:ring-0"
        type="text"
        placeholder="Full Name"
        value={pagination.fullName}
        onChange={(e) => {
          setPagination({
            ...pagination,
            fullName: e.target.value,
          })
        }}
      />

      <select
        value={pagination.lead_stage ?? ""}
        className="flex-1 px-4 py-2 text-sm font-light text-gray-800 border-gray-200 rounded-md focus:border-gray-300 focus:outline-none w-72 focus:ring-0"
        onChange={(e) => {
          setPagination({
            ...pagination,
            lead_stage: e.target.value,
          })
        }}
      >
        <option value="">All lead stages</option>
        <option value="New Lead">New Lead</option>
        <option value="Screening">Screening</option>
        <option value="Outreach">Outreach</option>
        <option value="Schedule">Schedule</option>
        <option value="Assign Closer">Assign Closer</option>
        <option value="Contract">Contract</option>
        <option value="Qualify">Qualify</option>
        <option value="Permit">Permit</option>
        <option value="Install">Install</option>
        <option value="Funded">Funded</option>
      </select>

      <select
        value={pagination.type ?? ""}
        className="flex-1 px-3 py-2 text-sm"
        onChange={(e) => {
          setPagination({
            ...pagination,
            type: e.target.value,
          })
        }}
      >
        <option value="">All types</option>
        <option value="Smart Home">Smart Home</option>
        <option value="Solar">Solar</option>
      </select>

      <select
        className="px-4 py-2 text-sm font-light text-gray-800 border-gray-200 rounded-md focus:border-gray-300 focus:outline-none focus:ring-0"
        value={date}
        onChange={(e) => {
          if (e.target.value === "CUSTOM") {
            setShowCustom(true)
          } else {
            setDate(e.target.value)
          }
        }}
      >
        {DATE.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>

      {showCustom && (
        <DatePicker
          selected={startDate}
          placeholderText="Custom Date"
          onChange={onChangeCreated}
          startDate={startDate}
          endDate={endDate}
          // showIcon
          isClearable
          className="py-2 z-100"
          customInput={
            <input
              placeholder="Select date"
              className="px-3 py-2 text-sm"
            />
          }
          selectsRange
          selectsDisabledDaysInRange
        />
      )}
    </div>
  )
}
